import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';

/**
 * 云转码Redux状态管理
 * 管理转码任务的状态、进度、错误信息等
 */
export const FJSliceCloudTranscoding = createSlice({
    name: 'cloudTranscoding',
    initialState: {
        // 当前转码任务列表
        transcodingTasks: [],

        // 转码状态
        transcodingStatus: FJConstant.DEFAULT,

        // 转码配置
        config: {
            mediaType: 'video',
            outputFormat: 'mp4',
        },
        // 回调函数
        onSuccess: null,
        onError: null,
    },
    reducers: {
        /**
         * 设置转码状态
         */
        setTranscodingStatus: (state, action) => {
            state.transcodingStatus = action.payload;
        },
        /**
         * 添加转码任务
         */
        addTranscodingTask: (state, action) => {
            const tasks = action.payload;
            const currentTaskList = state.transcodingTasks;
            state.transcodingTasks = [...currentTaskList, ...tasks];
        },

        /**
         * 更新转码任务
         */
        updateTranscodingTask: (state, action) => {
            const { updates } = action.payload;
            const { transcodingTasks } = state;
            const newTaskStateList = transcodingTasks.map(item => {
                const taskIdStatus = updates?.find(taskIdStatus =>
                    item.id ? taskIdStatus.id === item.id : taskIdStatus.tempId === item.tempId,
                );
                if (taskIdStatus) {
                    return { ...item, ...taskIdStatus, updatedAt: new Date().toISOString() };
                } else {
                    return item;
                }
            });
            state.transcodingTasks = newTaskStateList;
        },

        /**
         * 更新转码配置
         */
        updateTranscodingConfig: (state, action) => {
            state.config = {
                ...state.config,
                ...action.payload,
            };
        },

        /**
         * 重置转码状态
         */
        resetTranscodingState: state => {
            state.transcodingStatus = FJConstant.DEFAULT;
            state.transcodingTasks = [];
            state.onSuccess = null;
            state.onError = null;
        },

        setCloudTranscodingCallbacks: (state, action) => {
            state.onSuccess = action.payload.onSuccess;
            state.onError = action.payload.onError;
            state.onCancel = action.payload.onCancel;
            state.onConfirm = action.payload.onConfirm;
            state.onReupload = action.payload.onReupload;
        },
    },
});

// 导出actions
export const {
    setTranscodingStatus,
    addTranscodingTask,
    updateTranscodingTask,
    updateTranscodingConfig,
    resetTranscodingState,
    setCloudTranscodingCallbacks,
} = FJSliceCloudTranscoding.actions;

// 导出reducer
export default FJSliceCloudTranscoding.reducer;
